import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IsoLanguageValue, SiLanguageSwitcherComponent } from '@siemens/element-ng/language-switcher';
import { LocaleService } from '../../../core';

/**
 * Language switcher component that uses the Element SiLanguageSwitcherComponent.
 * Allows users to switch between available application locales.
 *
 * Note: By default, changing the locale will trigger a page reload to ensure
 * all Angular pipes and formatters use the new locale correctly.
 *
 * Usage:
 * ```html
 * <app-language-switcher />
 * ```
 */
@Component({
    selector: 'app-language-switcher',
    templateUrl: './language-switcher.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SiLanguageSwitcherComponent]
})
export class LanguageSwitcherComponent {
    private readonly localeService = inject(LocaleService);

    /**
     * Available languages for the switcher.
     * Maps locale codes to their translation keys.
     */
    protected readonly availableLanguages: IsoLanguageValue[] = this.localeService.availableLocales.map(locale => ({
        value: locale.code,
        name: locale.translationKey
    }));
}
